export default __webpack_public_path__ + "static/media/BNB.ebb600c2.svg";